/* ═══════════════════════════════════════════════════════════════
   PAW & PIGMENT — THEME JAVASCRIPT
   ═══════════════════════════════════════════════════════════════ */

document.addEventListener('DOMContentLoaded', () => {

  /* ── Custom cursor ──────────────────────────────────────────── */
  const cursor = document.getElementById('cursor');
  const ring   = document.getElementById('cursor-ring');
  if (cursor && ring && window.matchMedia('(hover: hover)').matches) {
    let mx = 0, my = 0, rx = 0, ry = 0;
    document.addEventListener('mousemove', e => {
      mx = e.clientX; my = e.clientY;
      cursor.style.left = mx + 'px';
      cursor.style.top  = my + 'px';
    });
    (function animRing() {
      rx += (mx - rx) * 0.12;
      ry += (my - ry) * 0.12;
      ring.style.left = rx + 'px';
      ring.style.top  = ry + 'px';
      requestAnimationFrame(animRing);
    })();
    document.querySelectorAll('a, button').forEach(el => {
      el.addEventListener('mouseenter', () => {
        cursor.style.width  = '6px';
        cursor.style.height = '6px';
        ring.style.width    = '50px';
        ring.style.height   = '50px';
        ring.style.opacity  = '0.3';
      });
      el.addEventListener('mouseleave', () => {
        cursor.style.width  = '10px';
        cursor.style.height = '10px';
        ring.style.width    = '36px';
        ring.style.height   = '36px';
        ring.style.opacity  = '0.55';
      });
    });
  }

  /* ── Scroll reveal ──────────────────────────────────────────── */
  const revealObs = new IntersectionObserver(entries => {
    entries.forEach(e => {
      if (e.isIntersecting) {
        e.target.classList.add('visible');
        revealObs.unobserve(e.target);
      }
    });
  }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });

  document.querySelectorAll('.reveal').forEach(el => revealObs.observe(el));

  /* ── Filter tabs ────────────────────────────────────────────── */
  document.querySelectorAll('.filter-tabs').forEach(group => {
    group.querySelectorAll('.filter-tab').forEach(tab => {
      tab.addEventListener('click', () => {
        group.querySelectorAll('.filter-tab').forEach(t => t.classList.remove('is-active'));
        tab.classList.add('is-active');
      });
    });
  });

  /* ── Product option buttons ─────────────────────────────────── */
  document.querySelectorAll('.option-buttons').forEach(group => {
    group.querySelectorAll('.option-btn').forEach(btn => {
      btn.addEventListener('click', () => {
        group.querySelectorAll('.option-btn').forEach(b => b.classList.remove('is-selected'));
        btn.classList.add('is-selected');
      });
    });
  });

  /* ── Product gallery thumbnails ─────────────────────────────── */
  document.querySelectorAll('.product-thumbnails').forEach(thumbs => {
    const mainImg = thumbs.closest('.product-gallery')?.querySelector('.product-main-image img');
    thumbs.querySelectorAll('.product-thumb').forEach(thumb => {
      thumb.addEventListener('click', () => {
        thumbs.querySelectorAll('.product-thumb').forEach(t => t.classList.remove('is-active'));
        thumb.classList.add('is-active');
        if (mainImg && thumb.querySelector('img')) {
          mainImg.src = thumb.querySelector('img').src;
        }
      });
    });
  });

  /* ── Add to cart feedback ───────────────────────────────────── */
  document.querySelectorAll('.btn-add-to-cart, .product-quick-add, .btn-atc').forEach(btn => {
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      const originalText = this.textContent;
      this.textContent = '✓ Added';
      this.style.background  = 'var(--sage)';
      this.style.color       = '#fff';
      this.style.borderColor = 'var(--sage)';
      setTimeout(() => {
        this.textContent = originalText;
        this.style.background  = '';
        this.style.color       = '';
        this.style.borderColor = '';
        // Increment cart count
        const badge = document.querySelector('.cart-count');
        if (badge) badge.textContent = parseInt(badge.textContent || 0) + 1;
      }, 1800);
    });
  });

  /* ── Cart quantity controls ─────────────────────────────────── */
  document.querySelectorAll('.cart-qty').forEach(ctrl => {
    const input = ctrl.querySelector('input');
    ctrl.querySelectorAll('button').forEach(btn => {
      btn.addEventListener('click', () => {
        const delta = btn.dataset.dir === '+' ? 1 : -1;
        const newVal = Math.max(1, parseInt(input.value || 1) + delta);
        input.value = newVal;
      });
    });
  });

  /* ── Upload drop zone ───────────────────────────────────────── */
  document.querySelectorAll('.upload-drop-zone').forEach(zone => {
    const input = zone.querySelector('input[type="file"]');

    zone.addEventListener('click', e => {
      if (e.target !== input) input?.click();
    });

    zone.addEventListener('dragover', e => {
      e.preventDefault(); zone.classList.add('is-dragover');
    });
    zone.addEventListener('dragleave', () => zone.classList.remove('is-dragover'));
    zone.addEventListener('drop', e => {
      e.preventDefault(); zone.classList.remove('is-dragover');
      if (e.dataTransfer.files.length) handleFileUpload(zone, e.dataTransfer.files[0]);
    });

    input?.addEventListener('change', e => {
      if (e.target.files.length) handleFileUpload(zone, e.target.files[0]);
    });
  });

  function handleFileUpload(zone, file) {
    zone.querySelector('.upload-drop-title').textContent = '✓ ' + file.name;
    zone.querySelector('.upload-drop-hint').textContent  = 'Great! Choose your style and size to continue.';
    const btn = zone.querySelector('.btn');
    if (btn) btn.textContent = 'Continue to checkout →';
    zone.style.borderColor = 'var(--gold)';
    zone.style.background  = 'rgba(196,154,82,.1)';
  }

  /* ── Smooth anchor scroll ───────────────────────────────────── */
  document.querySelectorAll('a[href^="#"]').forEach(a => {
    a.addEventListener('click', e => {
      const target = document.querySelector(a.getAttribute('href'));
      if (target) { e.preventDefault(); target.scrollIntoView({ behavior: 'smooth' }); }
    });
  });

  /* ── Mobile nav toggle ──────────────────────────────────────── */
  const navToggle = document.querySelector('.nav-toggle');
  const siteNav   = document.querySelector('.site-nav');
  if (navToggle && siteNav) {
    navToggle.addEventListener('click', () => {
      const isOpen = siteNav.classList.toggle('is-open');
      navToggle.setAttribute('aria-expanded', isOpen);
    });
  }

  /* ── Newsletter form ────────────────────────────────────────── */
  document.querySelectorAll('.newsletter-form').forEach(form => {
    form.addEventListener('submit', e => {
      e.preventDefault();
      const input  = form.querySelector('.newsletter-input');
      const submit = form.querySelector('.newsletter-submit');
      if (!input.value.trim()) return;
      submit.textContent = '✓ Joined';
      input.value = '';
      setTimeout(() => { submit.textContent = 'Join'; }, 3000);
    });
  });

});
